import H from 'constants/httpMethod.const';
import KPI_SCOPE from 'constants/staff/kpiScope.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import fromDtoToKpiSelection from 'dto/kpi/fromDtoToKpiSelection.dto';
import fromDtoToKpiSelectionsSetup from 'dto/kpi/fromDtoToKpiSelectionsSetup.dto';
import fromKpiSelectionToDto from 'dto/kpi/fromKpiSelectionToDto.dto';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import isEnumVal from 'utils/predicates/enum/isEnumVal.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const L = logger('beKpiSelection'); // eslint-disable-line no-unused-vars

// SEE: https://github.com/getslick/api.core/blob/staging/docs/KPI_selection.md

const DEFAULT_SCOPE = KPI_SCOPE.personal;

const fromAnyToEditScope = (scope) => (isEnumVal(KPI_SCOPE, scope) ? scope : L.warn('fromAnyToEditScope()', 'Unknown scope:', scope, 'returning:', DEFAULT_SCOPE));

const fromAnyToReadScope = (scope) =>
  KPI_SCOPE.personal === scope
    ? scope
    : KPI_SCOPE.business === scope || KPI_SCOPE.stylists === scope
      ? KPI_SCOPE.business
      : L.warn('fromAnyToReadScope()', 'Unknown scope:', scope, 'returning:', DEFAULT_SCOPE);

const reconfigureRead = (config) => (options, extra) => ({
  ...options,
  ...config,
  params: {
    scope: fromAnyToReadScope(extra?.scope),
  },
  fromDto: fromDtoToKpiSelectionsSetup,
  umsg: UMSG_TYPE.global,
});

const reconfigureEdit = (config) => (options, extra) => {
  const kpiId = fromAnyToInteger(extra?.id);

  if (!isPositiveInteger(kpiId)) L.warn('reconfigureEdit()', 'Invalid kpi id:', kpiId);

  return {
    ...options,
    ...config,
    params: {
      kpiId,
      scope: fromAnyToEditScope(extra?.scope),
    },
    data: extra?.data,
    fromDto: fromDtoToKpiSelection,
    toDto: fromKpiSelectionToDto,
    umsg: UMSG_TYPE.global,
  };
};

export const ibeKpiSelectionsRead = actionEndpointBe('ibeKpiSelectionsRead', H.get, 'metrics/kpi/:scope/selection/:salonId/', reconfigureRead({ inert: true }));

export const abeKpiSelectionsRead = actionEndpointBe('abeKpiSelectionsRead', H.get, 'metrics/kpi/:scope/selection/:salonId/', reconfigureRead({ inert: false }));

export const ibeKpiSelectionsDelete = actionEndpointBe('ibeKpiSelectionsDelete', H.del, 'metrics/kpi/:scope/:salonId/reorder/:kpiId/', reconfigureEdit({ inert: true }));

export const abeKpiSelectionsDelete = actionEndpointBe('abeKpiSelectionsDelete', H.del, 'metrics/kpi/:scope/:salonId/reorder/:kpiId/', reconfigureEdit({ inert: false }));

export const ibeKpiSelectionsMove = actionEndpointBe('ibeKpiSelectionsMove', H.patch, 'metrics/kpi/:scope/:salonId/reorder/:kpiId/', reconfigureEdit({ inert: true }));

export const abeKpiSelectionsMove = actionEndpointBe('abeKpiSelectionsMove', H.patch, 'metrics/kpi/:scope/:salonId/reorder/:kpiId/', reconfigureEdit({ inert: false }));

export const ibeKpiSelectionsCreate = actionEndpointBe('ibeKpiSelectionsCreate', H.post, 'metrics/kpi/:scope/:salonId/', reconfigureEdit({ inert: true }));

export const abeKpiSelectionsCreate = actionEndpointBe('abeKpiSelectionsCreate', H.post, 'metrics/kpi/:scope/:salonId/', reconfigureEdit({ inert: false }));
